import { jsx as s } from "react/jsx-runtime";
import '../../assets/Cell.css';const c = ({ children: l, className: e = "", ...o }) => /* @__PURE__ */ s("td", { className: "cell" + e, ...o, children: l });
export {
  c as Cell
};
//# sourceMappingURL=Cell.js.map
